import { render, staticRenderFns } from "./PolicyCoverage.vue?vue&type=template&id=10543c7a&scoped=true&"
import script from "./PolicyCoverage.vue?vue&type=script&lang=ts&"
export * from "./PolicyCoverage.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyCoverage.vue?vue&type=style&index=0&id=10543c7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10543c7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
